import React, { ReactElement } from 'react'
import styled from 'styled-components'
import colors from '../../lib/colors'
import { IColorTheme } from '../../types/itemTypes'

const Arrow = styled.div`
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  border-right: 7px solid ${colors.black};
`
const Button = styled.button`
  background-color: ${colors.white};
  color: inherit;
  border: 1px solid ${colors.darkestGray};
  min-height: 40px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px;
  box-sizing: border-box;
  cursor: pointer;
  font-size: inherit;
  &:hover {
    background-color: ${({ theme }): string => theme.colourTheme.colourHighlight};
    color: ${({ theme }): string => theme.colourTheme.colourTextOnHighlight};
  }

  @media (min-width: ${({ theme }): string => (theme.keepLeftLonger ? '700px' : '900px')}) {
    position: absolute;
    left: 25px;
  }

  font-family: ${(props): string => props.theme.font};
`
type Props = {
  colourTheme: IColorTheme
  onClick: () => void
  keepLeftLonger: boolean
  font: string
}
export default function BackButton(props: Props): ReactElement {
  const {
    colourTheme, onClick, keepLeftLonger, font,
  } = props

  return (
    <Button theme={{ colourTheme, keepLeftLonger, font }} onClick={onClick}>
      <Arrow />
      Back
    </Button>
  )
}
